<!--
    Created by 杨莎莎 on 2025/08/11.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：已关联小区
-->
<style lang="less">

</style>

<template>
  <yg-drawer
    width="60%"
    :show-bottom="false"
    :title="'关联小区' + (model.merchantCompany ? '(商户名称：' + model.merchantCompany +')' : '')"
    @on-close="_close"
  >
    <div
      slot="content"
      style="height: 100%"
    >
      <div>
        <yg-setting-area
          :items="settingItems"
          :total="page.total"
          @on-click="_clickSetting"
        />
      </div>
      <div class="padding-primary-top">
        <yg-table
          :columns="tableColumns"
          :data="tableData"
          :page="page"
          @on-page-change="onChangePage"
        />
      </div>
      <!--选择关联小区列表弹窗-->
      <v-select-merchant
        v-if="dialog.addMerchantModel"
        :model="dialog.addMerchantModel"
        @on-close="dialog.addMerchantModel=null"
        @on-sure="_clickSureAddMerchant"
      />
    </div>
  </yg-drawer>
</template>

<script>
// import { AgentMerchantDetailModel, AssociateMerchantListModel } from '@/pages/agent/list/model/AgentMerchantDataModel';
import { AgentMerchantDetailModel, AssociateMerchantListModel } from '../model/AgentMerchantDataModel';
import vSelectMerchant from './selectMerchant.vue';
import AgentApiSet from '@/request/api/AgentApiSet';

export default {
  components: { vSelectMerchant },
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      settingItems: [
        BaseSettingModel.initData('新增关联小区', 'add', 'md-add-circle'),
        BaseSettingModel.initData('刷新数据', 'refresh', 'md-refresh-circle')
      ],
      tableColumns: [
        BaseTableColumn.initData('index'),
        BaseTableColumn.initData('communityName', '已关联小区名称').setSpan({}),
        BaseTableColumn.initData('communityId', '已关联小区编码').setSpan({ canCopy: true }),
        BaseTableColumn.initData('operatorName', '操作人').setSpan({ canHidePhone: true }),
        BaseTableColumn.initData('operatorTime', '操作时间').setSpan({}),
        BaseTableColumn.initData('setting', '操作').setWidth(140).setAlign('center').setButtons([
          { title: '解除关联', name: 'lift' }
        ], ({ name }, row, index) => {
          this.$Modal.confirm({
            title: '温馨提示',
            content: '确定要解除关联小区吗？',
            onOk: () => {
              // console.log('确定发送');
              this.liftCommunity(row);
            }
          });
        })
      ],
      page: { current: 1, total: 0 },
      tableData: [],
      dialog: {
        addMerchantModel: null
      }
    };
  },
  created () {
    this.onChangePage(1);
  },
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onChangePage (page) {
      this.page.current = page;
      this.requestData();
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSearch (option) {
      this.searchOption = option;
      this.page.current = 1;
      this.requestData();
    },
    _clickSetting (key) {
      if (key === 'add') {
        this.dialog.addMerchantModel = AgentMerchantDetailModel.createAdditionModel();
      } else if (key === 'refresh') {
        this.onChangePage(1);
      }
    },
    _clickSureAddMerchant (data) {
      // this.requestAdd(data.merchantCode);
      this.requestAdd(data);
    },
    _close () {
      this.$emit('on-close');
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求数据
    requestData () {
      const api = AgentApiSet.merchantCommunityRelationList;
      api.params = {
        // thirdMerchantCode: this.model.merchantCode,
        merchantCode: this.model.merchantCode,
        pageNo: this.page.current,
        pageSize: this.$config.pageSize
      };
      this.tableData = [];
      this.page.total = 0;
      this.$http(api).then(res => {
        // console.log('7777', res);
        const resData = res.data;
        this.tableData = AssociateMerchantListModel.initListWithDataList(resData.rows);
        this.page.total = resData.total;
      });
    },
    // 解除关联
    liftCommunity (row) {
      const api = AgentApiSet.removeMerchantCommunityRelation;
      api.params = {
        communityId: row.communityId
      };
      this.$http(api).then(res => {
        this.$Message.success('操作成功');
        // this.dialog.addMerchantModel = null;
        this.onChangePage(1);
      });
    },

    // 请求新增关联商户/确认关联
    requestAdd (data) {
      const api = AgentApiSet.merchantCommunityRelation;
      // console.log('data', data);
      api.params = {
        merchantCode: this.model.merchantCode,
        communityId: data.communityId
        // thirdMerchantCode: this.model.merchantCode
      };
      this.$Modal.confirm({
        title: '温馨提示',
        content: '确定要关联小区吗？',
        onOk: () => {
          this.$http(api).then(res => {
            this.$Message.success('操作成功');
            this.dialog.addMerchantModel = null;
            this.onChangePage(1);
          });
        }
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
